export const GOSUSLUGI = 'https://www.gosuslugi.ru/';
export const SFR = 'https://sfr.gov.ru/';
export const FNS = 'https://service.nalog.ru/inn.do';
